export const isValidDate = (date: string | null) => {
  return (
    date !== '0001-01-01T00:00:00' && date !== null && !isNaN(Date.parse(date))
  );
};
